/**
 * UUID v4 generator, as found at https://gist.github.com/jed/982883
 *
 * @param {?number} a Optional placeholder used to generate the UUID.
 *
 * @return {string}
 */
const uuid = (a = null) => a
  ? (a ^ (Math.random() * 16 >> a / 4)).toString(16)
  : ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, uuid);

export default uuid;



// WEBPACK FOOTER //
// ./src/utils/uuid.js